export default __webpack_public_path__ + "static/media/port22.71d6bfcb.jpg";